
import { inject, Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { StorageService } from '../services/storage.service';
import { Observable } from 'rxjs';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  private readonly storage = inject(StorageService);

   intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {

    if (req.headers.has('skipAuth')) {
      const newHeaders = req.headers.delete('skipAuth');
      const cleanReq = req.clone({ headers: newHeaders });
      return next.handle(cleanReq);
    }

    const token = this.storage.getToken();

    if (token) {
      const isFormData = req.body instanceof FormData;
      const headers: Record<string, string> = {
        Authorization: `Bearer ${token}`,
        Accept: 'application/json, text/plain',
      };
      if (!isFormData) {
        headers['Content-Type'] = 'application/json';
      }
      req = req.clone({ setHeaders: headers });
    }

    return next.handle(req);
  }
}